import * as EntitiesActions from '../../../store/entities/entities.actions';
import * as OrderGridHeaderActions from '../../../store/orders/grid/orders.grid.header.actions';
import * as OrdersActions from '../../../store/orders/orders.actions';
import { InventoryService } from '../../../services/inventory-service';
import * as SellerActions from '../../../store/seller/seller.actions';
import { OrdersDrawerService } from '../../../services/orders-drawer-service';
import * as Actions from './orders.drawer.actions';
import * as InventoryActions from '../../inventory/inventory.actions';
import { SET_SELECTED_ORDERS } from '../selected-orders/orders.selected-orders.actions';
import { APP_INITIALIZATION } from '../../core/base-actions';
import { emptyObject } from 'ui-components/default-props/empty';
import { FeatureFlags } from '../../../feature-flags/feature-flags';

const initialState = {
  orders: [],
  error: undefined,
  isLoading: false,
  isLoadingRates: false,
  isCalculatingRates: false,
  sectionStates: {
    order: {
      open: true,
    },
    otherShippingOptions: {
      open: true,
    },
    pickupInformation: {
      open: true,
    },
    'bulk-update': {
      open: true,
    },
    customer: {
      open: true,
    },
    customs: {
      open: true,
    },
    notes: {
      open: true,
    },
    summary: {
      open: true,
    },
    tags: {
      open: true,
    },
    'apply-preset': {
      open: true,
    },
    'address-validation': {
      open: true,
    },
    'fulfillment-plans': {
      open: true,
    },
    'ordered-items': {
      open: true,
    },
  },
  lastAppliedRecommendation: {},
};

const onGetDrawerOrdersRequest = (state) => {
  return {
    ...state,
    isLoading: true,
    error: undefined,
  };
};

const onGetDrawerOrdersSuccess = (state) => {
  return {
    ...state,
    error: undefined,
    isLoading: false,
  };
};

const onGetDrawerOrdersFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    error,
    isLoading: false,
  };
};

const onClearDrawerOrders = (state) => {
  return {
    ...state,
    isLoading: false,
    error: undefined,
    orders: [],
    addressAndSalesOrders: [],
  };
};

const onSuccessfulAddressValidation = (state) => {
  return {
    ...state,
    isValidatingAddress: false,
  };
};

const onSetSectionState = (state, action) => {
  const { sectionId, sectionState } = action;

  const { sectionStates } = state;
  return {
    ...state,
    sectionStates: {
      ...sectionStates,
      [sectionId]: sectionState,
    },
  };
};

const initializeDrawerConfiguration = (state, action) => {
  const { data } = action;
  const { userSettings } = data;
  const { enableSingleFulfillmentPlanOrdersGridSidebarDrawerRedesign } = new FeatureFlags({ state });

  const singleSelectionOrdersDrawerModules = OrdersDrawerService.getSingleModulesFromUserSettings(
    userSettings,
    enableSingleFulfillmentPlanOrdersGridSidebarDrawerRedesign,
  );
  const multiSelectionOrdersDrawerModules = OrdersDrawerService.getMultiModulesFromUserSettings(userSettings);
  return {
    ...state,
    singleOrderDrawerModulesList: singleSelectionOrdersDrawerModules.map((mod) => mod.name),
    multiOrderDrawerModulesList: multiSelectionOrdersDrawerModules.map((mod) => mod.name),
    allOrderDrawerModulesList: multiSelectionOrdersDrawerModules.map((mod) => mod.name),
  };
};

const reorderSingleSelectionDrawerModules = (state, action) => {
  const { newOrderOfModules } = action;
  return {
    ...state,
    singleOrderDrawerModulesList: newOrderOfModules,
  };
};

const reorderMultiSelectionDrawerModules = (state, action) => {
  const { newOrderOfModules } = action;
  return {
    ...state,
    multiOrderDrawerModulesList: newOrderOfModules,
  };
};

const updateOrdersFromSelection = (state, selectedOrderIds) => {
  return {
    ...state,
    orders: state.orders.filter((order) => selectedOrderIds.includes(order.salesOrder.salesOrderId)),
  };
};

const actionTypeToReducerMap = {
  [Actions.GET_DRAWER_ORDERS_REQUEST]: (state, action) => onGetDrawerOrdersRequest(state, action),
  [Actions.GET_DRAWER_ORDERS_SUCCESS]: (state) => onGetDrawerOrdersSuccess(state),
  [Actions.GET_DRAWER_ORDERS_FAILURE]: (state, action) => onGetDrawerOrdersFailure(state, action),
  [Actions.CLEAR_DRAWER_ORDERS]: (state) => onClearDrawerOrders(state),
  [Actions.VALIDATE_DRAWER_ADDRESS_SUCCESS]: (state) => onSuccessfulAddressValidation(state),
  [Actions.VALIDATE_DRAWER_ADDRESS_FAILURE]: (state) => onSuccessfulAddressValidation(state),
  [Actions.SET_SECTION_STATE]: (state, action) => onSetSectionState(state, action),
  [InventoryActions.GET_STOCK_LEVELS_REQUEST]: (state) => ({
    ...state,
    inventoryInfo: { isLoading: true },
  }),
  [InventoryActions.GET_STOCK_LEVELS_FAILURE]: (state) => ({
    ...state,
    inventoryInfo: { isLoading: false },
  }),
  [InventoryActions.GET_STOCK_LEVELS_SUCCESS]: (state, { inventoryInfo }) => InventoryService.setupInventoryInfo(inventoryInfo, state),
  [OrderGridHeaderActions.ORDER_GRID_GET_RATES]: (state) => ({
    ...state,
    isLoadingRates: true,
    isCalculatingRates: true,
  }),
  [OrderGridHeaderActions.ORDER_GRID_GET_RATES_REQUEST]: (state) => ({
    ...state,
    isLoadingRates: true,
    isCalculatingRates: true,
  }),
  [OrderGridHeaderActions.ORDER_GRID_RATES_UPDATED]: (state) => ({
    ...state,
    isCalculatingRates: false,
  }),
  [OrderGridHeaderActions.ORDER_GRID_RATES_CLEAR]: (state) => ({
    ...state,
    isLoadingRates: false,
    isCalculatingRates: false,
  }),
  [EntitiesActions.ENTITIES_BULKLOAD]: (state) => ({
    ...state,
    isLoadingRates: state.isCalculatingRates,
  }),
  [OrdersActions.GET_ORDERS_FAILURE]: (state) => ({
    ...state,
    isLoadingRates: false,
    isCalculatingRates: false,
  }),
  [APP_INITIALIZATION]: (state, action) => initializeDrawerConfiguration(state, { data: action.initialData }),
  [SellerActions.GET_SELLER_DATA_SUCCESS]: (state, action) => initializeDrawerConfiguration(state, action),
  [Actions.REORDER_SINGLE_SELECTION_DRAWER_MODULES]: (state, action) => reorderSingleSelectionDrawerModules(state, action),
  [Actions.REORDER_MULTI_SELECTION_DRAWER_MODULES]: (state, action) => reorderMultiSelectionDrawerModules(state, action),
  [SET_SELECTED_ORDERS]: (state, { selectedOrderIds }) => updateOrdersFromSelection(state, selectedOrderIds),
  [Actions.VALIDATE_DRAWER_ADDRESS_REQUEST]: (state) => ({
    ...state,
    isValidatingAddress: true,
  }),
  [OrderGridHeaderActions.ORDER_GRID_VALIDATE_ADDRESS]: (state) => ({
    ...state,
    isValidatingAddress: true,
  }),
  [Actions.BULK_APPLY_RECOMMENDATIONS]: (state, { bulkUpdateJobGuid }) => {
    return {
      ...state,
      lastAppliedRecommendation: {
        jobId: bulkUpdateJobGuid,
        appliedSavings: emptyObject,
        isApplyingRecommendations: true,
        appliedSuccessfully: false,
      },
    };
  },
  [Actions.BULK_APPLY_RECOMMENDATIONS_SUCCESS]: (state, { bulkUpdateJobGuid, amountSaved }) => {
    if (bulkUpdateJobGuid !== state.lastAppliedRecommendation.jobId) {
      return state;
    }

    return {
      ...state,
      lastAppliedRecommendation: {
        jobId: bulkUpdateJobGuid,
        appliedSavings: amountSaved,
        isApplyingRecommendations: false,
        appliedSuccessfully: true,
      },
    };
  },
};

export const reduce = (state = initialState, action) => {
  const reducer = actionTypeToReducerMap[action.type];
  if (!reducer) {
    return state;
  }
  return reducer(state, action);
};

export { namespace } from './orders.drawer.reducer.metadata';
